<template>
  <div class="community-share">
    <h3>{{title}}</h3>
    <JourneyMedia v-if="media" :media="media"/>
    <div class="description" v-html="description"></div>
    <a :href="communityLink"
    @click="handleLink"
    class="link-button">
      <i18n tag="span" path="message.open-link">
        {{ buttonText }}
      </i18n>
      <RightArrow
      :opacity="1"
      fill="white">
      </RightArrow>
    </a>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.community-share {
  .link-button {
    display: inline-block;
    color: white;
    background: rgb(0, 127, 255);
    &:hover {
      background: darken(rgb(0, 127, 255), 10%);
    }
    .right-arrow::v-deep {
      margin-left: 5px;
    }
  }
}
</style>

<script>
import { mapActions } from "vuex";
import RightArrow from "@/common/icons/RightArrow"
import JourneyMedia from "./JourneyMedia";

export default {
  components: {RightArrow, JourneyMedia},
  props: {
    description: {
      type: String
    },
    title: {
      type: String
    },
    channel: {
      type: Object,
      required: false
    },
    started: {
      type: Boolean,
      default: false
    },
    tag: {
      default: null
    },
    channelMember: {
      type: Boolean
    },
    media: {
      type: Object,
    },
  },
  computed: {
    buttonText() {
      return this.channel ? this.channel.name : this.$t('message.community');
    },
    communityLink() {
      if (this.channel) {
        return `/community/channels/${this.channel.id}`;
      } else {
        return `/community`;
      }
    }
  },
  methods: {
    closeAndCreatePost() {
      this.$store.commit("setSelectedTag", this.tag);
      this.$store.commit("setShowJourney", false);
      if (this.channel && this.channelMember || !this.channel) {
        this.$store.commit("setCreatePost");
      }
    },
    handleLink(event) {
      if (!this.started) {
        event.preventDefault();
        this.promptStartJourney();
      }
    },
    ...mapActions(["promptStartJourney"])
  }
}
</script>
